import React from 'react';
import _ from 'lodash';
import { Link, withRouter } from 'react-router-dom';
import { Translate } from 'core/translate';

const LanguageToggle = props => {
  const {
    appResources,
    selections,
    serializedState,
    postalCode,
    pathname,
    uiPath
  } = props;
  const {
    country,
    language,
    brand,
    carline,
    year,
    bodyStyle,
    languageToggleUrls
  } = appResources;
  const selectedLanguage = language;
  const languageMaps = {
    en: 'component.language.toggle.english',
    fr: 'component.language.toggle.french'
  };
  const { rpos, accessories, styleId } = selections;
  const query = {
    styleId: styleId,
    rpo: rpos
      .slice()
      .concat(accessories)
      .join(','),
    ss: serializedState,
    postalCode: postalCode
  };

  const queryString = _.keys(query)
    .filter(key => query[key])
    .map(key => `${key}=${query[key]}`)
    .join('&');

  const languages = languageToggleUrls.map(function(languageConfig) {
    const language = languageConfig.language;
    const baseUrl = [
      languageConfig.url,
      _.trimStart(uiPath, '/'),
      language,
      country,
      brand,
      carline,
      year,
      bodyStyle
    ].join('/');
    const url = `${baseUrl}${pathname}`;

    return {
      url: url + '?' + queryString,
      text: languageMaps[language],
      lang: language
    };
  });

  if (languages.length === 0) {
    return null;
  }

  const languageItems = languages.map(language => {
    const languageClassName = `language-toggle__item language-toggle__link stat-text-link ${
      language.lang === selectedLanguage ? 'language-toggle__active' : ''
    }`;
    return (
      <a
        className={languageClassName}
        href={language.url}
        data-dtm="footer"
        key={language.lang}>
        <Translate value={language.text} />
      </a>
    );
  });

  return (
    <li className="footer__item">
      <span className="language-toggle__item language-toggle__label">
        <Translate value="component.language.toggle.label" />
      </span>
      {languageItems}
    </li>
  );
};

const FooterItem = ({ id, visible, url, label }) => {
  if (!visible) {
    return null;
  }

  return (
    <li className="footer__item">
      <a
        id={id}
        className="footer__link stat-text-link"
        data-dtm="footer"
        href={url}>
        <Translate value={label} />
      </a>
    </li>
  );
};

const AdChoicesFooterItem = ({ pathname, adChoicesUrl }) => {
  if (!adChoicesUrl) {
    return null;
  }

  return (
    <li className="footer__item">
      <Link
        to={`${pathname}/ads`}
        className="footer__link stat-text-link"
        data-dtm="footer">
        <img
          className="footer__image"
          alt=""
          src="//c.betrad.com/pub/icon1.png"
        />
        <Translate value="byo.footer.adchoice" />
      </Link>
    </li>
  );
};

const Footer = props => {
  const {
    sitemap,
    appResources,
    selections,
    serializedState,
    postalCode,
    uiPath,
    location,
    isFamilyFirst
  } = props;

  const { country, urls } = appResources;
  const {
    adChoicesUrl,
    privacyPolicyUrl,
    legalInformationUrl,
    copyrightTrademarkUrl
  } = urls;
  const pathname = location.pathname;

  return (
    <div className="row">
      <div className="footer">
        <div className="footer__disclaimer">
          <Translate value="byo.footer.disclaimer" />
        </div>
        <ul className="footer__links">
          <li className="footer__item footer__copy">
            <Translate value="byo.footer.gm" />
          </li>
          <FooterItem
            id="footer-copyright-link"
            visible={country === 'US'}
            url={copyrightTrademarkUrl}
            label="byo.footer.copyright"
          />
          <FooterItem
            id="footer-sitemap-link"
            visible={!isFamilyFirst && country === 'US'}
            url={sitemap || '/sitemap'}
            label="byo.footer.sitemap"
          />
          <FooterItem
            id="footer-privacy-link"
            visible={privacyPolicyUrl}
            url={privacyPolicyUrl}
            label="byo.footer.privacy"
          />
          <AdChoicesFooterItem
            pathname={pathname}
            adChoicesUrl={adChoicesUrl}
          />
          <FooterItem
            id="footer-legal-information-link"
            visible={legalInformationUrl}
            url={legalInformationUrl}
            label="byo.footer.legal.information"
          />
          <LanguageToggle
            appResources={appResources}
            selections={selections}
            serializedState={serializedState}
            postalCode={postalCode}
            pathname={pathname}
            uiPath={uiPath}
          />
        </ul>
      </div>
    </div>
  );
};

export default withRouter(Footer);
